export const nameLocales = {
  ua: 'Будь ласка, використовуйте тільки літери (а-я або А-Я) або тільки прогалини',
  ru: 'Пожалуйста, используйте только буквы (а-я или А-Я) или только пробіли',
  en: 'Please use only letters (a-z or A-Z) or spaces only'
}
export const requiredLocales = {
  ua: "Це обов'язкове поле",
  ru: 'Это обязательное поле',
  en: 'This is a required field'
}

export const emailLocales = {
  ua: "Повинна бути діюча адреса електронної пошти",
  ru: 'Должен быть действующий адрес электронной почты',
  en: 'Should be a valid email'
}

export const phoneLocales = {
  ua: "Будь ласка введіть дійсний номер телефону. Наприклад (123) 456-7890",
  ru: 'Введите действительный номер телефона. Например (123) 456-7890',
  en: 'Please enter a valid phone number. For example (123) 456-7890'
}

export const captchaLocales = {
  ua: 'Результат має збігатися з розв\'язком рівняння',
  ru: 'Результат должен совпадать с решением уравнения',
  en: 'The result must match the solution of the equation'
}

export const inputLabelsLocales = {
  name: {
    ua: "ім'я",
    ru: 'Имя',
    en: 'Name'
  },
  email: {
    ua: "Електронна пошта",
    ru: 'Электронная почта',
    en: 'Email'
  },
  phone: {
    ua: "НОМЕР ТЕЛЕФОНУ",
    ru: 'НОМЕР ТЕЛЕФОНА',
    en: 'PHONE NUMBER'
  },
  message: {
    ua: "ПОВІДОМЛЕННЯ",
    ru: 'СООБЩЕНИЕ',
    en: 'MESSAGE'
  },
}

export const placeholderLocales = {
  name: {
    ua: "Ваше ім'я",
    ru: 'Ваше имя',
    en: 'Your name'
  },
  email: {
    ua: "Ваша адреса електронної пошти",
    ru: 'Ваш адрес электронной почты',
    en: 'Your email'
  },
  message: {
    ua: "Ваше повідомлення...",
    ru: 'Ваше сообщение...',
    en: 'Your message here...'
  },
  phone: {
    ua: "Ваш номер телефону",
    ru: 'Ваш номер телефона',
    en: 'Your phone number'
  },
  captcha: {
    ua: "Результат",
    ru: 'Результат',
    en: 'Result'
  },
}

export const buttonLocales = {
  ua: "Відправити",
  ru: 'Отправить',
  en: 'Send'
}

export const titleLocales = {
  ua: "Заповніть форму нижче і ми зв'яжемося з Вами",
  ru: 'Заполните форму ниже и мы свяжемся с Вами',
  en: 'Fill out the form below and we will contact you'
}

export const toastSuccessMessage = {
  ua: "Ваше повідомлення було надіслано",
  ru: 'Ваше сообщение было отправлено',
  en: 'Your message has been send'
}